/* eslint-disable react/prop-types */
import { Button, Modal } from "react-bootstrap"
import { useSelector } from "react-redux"

const DeleteModal = ({ showDeleteModal, handleCancelDelete, currentEndorsementId, handleConfirmDelete }) => {
    const { data: endorsements } = useSelector((state) => state.endorsement)

    return (
        <Modal
            show={showDeleteModal}
            onHide={handleCancelDelete}
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    Are you sure you want to delete{" "}
                    <strong>
                        {endorsements?.find((endorsement) => endorsement?.id === currentEndorsementId)?.name || ""}
                    </strong>
                    ?
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn-sm"
                    variant="secondary"
                    onClick={handleCancelDelete}>
                    Cancel
                </Button>
                <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleConfirmDelete}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteModal
